/**
 * 牌桌背景音乐。事件音仍走 Web Audio；长音乐使用原生 Audio，避免把整首歌解码进内存。
 * 浏览器禁止无手势自动播放，所以第一次 pointerdown 只负责解锁；之后开关、前后台切换
 * 都复用同一个元素。页面不可见时暂停，回来后从原位置继续。
 */

const MUSIC_VOLUME = 0.13
const DUCKED_VOLUME = 0.045
const MUSIC_URL = '/audio/soiree.m4a'

let audio: HTMLAudioElement | null = null
let enabled = true
let active = false
let unlocked = false
let duckTimer: ReturnType<typeof setTimeout> | null = null

function getAudio(): HTMLAudioElement | null {
  if (audio !== null) return audio
  const AudioCtor = globalThis.Audio
  if (typeof AudioCtor !== 'function') return null
  audio = new AudioCtor(MUSIC_URL)
  audio.loop = true
  audio.preload = 'metadata'
  audio.volume = MUSIC_VOLUME
  return audio
}

function shouldPlay(): boolean {
  return enabled && active && unlocked && globalThis.document?.visibilityState !== 'hidden'
}

function sync(): void {
  const a = getAudio()
  if (a === null) return
  if (!shouldPlay()) {
    a.pause()
    return
  }
  void a.play().catch(() => {
    // 仍被自动播放策略拦截时，下一次真实手势会再次尝试。
    unlocked = false
  })
}

export function configureBackgroundMusic(next: { readonly enabled: boolean; readonly active: boolean }): void {
  enabled = next.enabled
  active = next.active
  sync()
}

export function unlockBackgroundMusic(): void {
  unlocked = true
  sync()
}

export function syncBackgroundMusicVisibility(): void {
  sync()
}

/** 重要提示音期间把音乐压低，结束后恢复；连续提示会顺延恢复时间。 */
export function duckBackgroundMusic(ms = 420): void {
  if (audio === null || audio.paused) return
  audio.volume = DUCKED_VOLUME
  if (duckTimer !== null) clearTimeout(duckTimer)
  duckTimer = setTimeout(() => {
    duckTimer = null
    if (audio !== null) audio.volume = MUSIC_VOLUME
  }, ms)
}

/** 仅供测试。 */
export function __resetBackgroundMusic(): void {
  if (duckTimer !== null) clearTimeout(duckTimer)
  audio?.pause()
  audio = null
  enabled = true
  active = false
  unlocked = false
  duckTimer = null
}
